// eslint-disable-next-line boundaries/external
export { light as ColorsLight } from '@tellent/design-tokens';

export type { TextToken, BackgroundToken, SupportedThemesT, Theme, ThemeName } from './lib/types';
export {
  RECRUITEE_THEME_LS_KEY,
  RECRUITEE_THEME_MIGRATED_LS_KEY,
  RECRUITEE_THEME_DEFAULT,
  providerEffectiveThemeFactory,
  injectEffectiveThemeFactory,
  SupportedThemes,
} from './lib/types';

export { ThemeImagePipe, ThemedImageTuple } from './lib/pipes/theme-image.pipe';
